import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy Emergent-managed OAuth callback. Direct Google OAuth (via
 * `@react-oauth/google`) does not redirect to a callback URL — it returns
 * the ID token inline through a JS event. We keep this route so any old
 * bookmarked URL just lands on /login instead of a 404.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    nav("/login", { replace: true });
  }, [nav]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#04302E] text-white">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-[#7BD3CE] border-t-transparent" />
        <p className="mt-4 text-sm">Redirecting…</p>
      </div>
    </div>
  );
}
